import { render } from "./Modal2.vue?vue&type=template&id=526bdcf9&scoped=true"
import script from "./Modal2.vue?vue&type=script&lang=js"
export * from "./Modal2.vue?vue&type=script&lang=js"

import "./Modal2.vue?vue&type=style&index=0&id=526bdcf9&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526bdcf9"]])

export default __exports__